import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import {Router, NavigationExtras, ActivatedRoute} from '@angular/router';
import { FormControl, FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';

import { environment } from '../../../environments/environment';
import { ProjectmanagementService } from '../../service/projectmanagement.service';
import { SchoolManagementService } from '../../../../../schoolmanagement/src/app/service/schoolmanagement.service';
import { UserManagementService } from '../../../../../tools/src/service/user.management.service';
import { Project, Grade, Year, Subject, School, SchoolCategory, Partner, ProjPartner, ProjAdmin, Country, Region, User, Role } from '../../model/project.model';
import * as projectforms from '../../forms/projectmanagement.form';
import { MyErrorHandler } from '../../errorhandler/errorhandler';

import { CtlSchoolForm } from '../../forms/school/CtlSchoolForm';
import { CtlPartnerForm } from '../../../../../tools/src/lib/forms/partner/CtlPartnerForm';
import { CtlNewUserForm } from '../../../../../tools/src/lib/forms/newuser/CtlNewUserForm';

import { ProjectGradeComponent } from '../../forms/projectGrade/ctl.project.grade.component';
import { ProjectSubjectComponent } from '../../forms/projectSubject/ctl.project.subject.component';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from '../../../../../tools/src/lib/tools.service';

import { TabGroup } from '@eds/vanilla';
import { Dialog } from '@eds/vanilla';

import { OrderByPipe } from 'ngx-pipes';
import { Subject as Sub } from 'rxjs';

declare var jQuery;

@Component({
  selector: 'app-projectoverview',
  templateUrl: './projectoverview.component.html',
  styleUrls: ['./projectoverview.component.css'],
  providers: [UserManagementService, SchoolManagementService, ToolsService, OrderByPipe]
})
export class ProjectoverviewComponent implements OnInit, AfterViewInit {

  loggedInUser: any;
  // @ViewChild(CtlFormModal)
  // private partnerModal: CtlFormModal;
  @ViewChild('overviewTabs') overviewTabs;
  @ViewChild(CtlPartnerForm)
  private partnerForm: CtlPartnerForm;
  @ViewChild(CtlNewUserForm)
  private userForm: CtlNewUserForm;
  @ViewChild(CtlSchoolForm)
  private schoolForm: CtlSchoolForm;
  @ViewChild(ProjectGradeComponent)
    private formProjectGrade: ProjectGradeComponent;
  @ViewChild(ProjectSubjectComponent)
    private formProjectSubject: ProjectSubjectComponent;
  btnSendStatus = true;
  btnSendText = '';
  environment: any;
  userFormGroup: FormGroup = new FormGroup(projectforms.formUser);
  admin_id: string;
  adminData: any;

  // communication
  // toChild: Subject<any> = new Subject();

  projectForm = projectforms.projectForm;
  projLeadPartner: any;
  projAdminList: any[];
  projLeadAdmin: any;
  projOnlyAdminList: any[] = [];
  projOnlyAdminListArr: any[];
  removeGradesArr = [];
  isSubjectRemoved = false;
  project_id: string;
  school_id: string;
  sub: any;
  projectData: Project;
  projectShortName: string;
  schoolListData: School[];
  schoolListDataAbs: School[];
  schoolCategoryList: SchoolCategory[] = [];
  countryList: Country[];
  country: Country;
  regionList: Region[] = [];
  projPartnerList: ProjPartner[];
  partnerList: Partner[];
  curPartner: any;
  userListData: any[] = [];
  roleList: Role[] = [];
  loaded = false;
  modalType: string;
  modalLoading: boolean;
  partnerData: any;
  modalInfo: string;
  gradecheckArr = [];
  partnerEnableDisable = false;
  propertyName: string;
  propertyNameSorting: string;
  orderType = true;
  isSorted = false;
  sortedClass: string;

  titleProjectModal = 'Add new project';
  titleSchoolModal = 'Add new school';
  titlePartnerModal = 'Add new secondary partner';
  titleAdminModal = 'Add new admin';
  partnerModalType = 'add';
  titleGradesModal = 'Project grades';
  btnTextAdd = 'Add';
  btnTextSend = '';
  btnStatusAdd = true;
  btnTextCancel = 'Cancel';
  viewType = '';
  curView = 'read';

  btnTextEdit = 'Edit';
  btnStatusEdit = true;

  gridView = true;
  page = 1;
  noOfItems = 9;

  showSetupProject = false;
  showAddNewSchool = false;
  activeSetupProjectTab = true;
  activeSchoolTab = true;
  activeGradeTab = false;
  activePartnerTab = false;
  activePaTab = false;
  error = '';
  message = '';

  term = '';
  term1 = '';
  term2 = '';
  term3 = '';
  gterm = '';
  cterm = '';
  sterm = '';

  uname = '';
  urole = '';
  upart = '';
  ugrade = '';
  uclass = '';
  usubject = '';
  ustatus = '';

  isProjectAdmin = false;

  filterBy = {
    region: '',
    category: ''
  };

  iconColor = {
    stringToColorHash: {},
    nextVeryDifferntColorIdx: 1,
    veryDifferentColors: ['#89ba17', '#89ba17']
  };

  titleMessage; // confirm message for alert modal
  subTitleMessage; // confirm message for alert modal
  detailMessage; // confirm message for alert modal
  listMessage;//list message
  detailMessageLine1; // confirm message for alert modal
  confirmFor;

  first = true;

  // grade step
  gradeYearForm: FormGroup;
  yearList: Year[] = [];
  projGradeList: Grade[] = [];
  gradeList: Grade[] = [];

  // subject step
  subjectsList: Subject[] = [];
  subjectListAbs: Subject[] = [];
  selectedSubjectsList: Subject[] = [];
  tempSelectedSubjectsList: Subject[] = [];
  projSubjectList: Subject[];
  subject = '';
  loginUserRole = '';

  removedSubjects = [];
  categorySelectConfig: any;
  regionSelectConfig: any;
  roleSelectConfig: any;
  partnerSelectConfig: any;
  partnerListWithoutType = [];
  btnEmailStatus: boolean;
  detailMessage1: string;
  detailMessage2: string;
  cancelClicked : Sub<void> = new Sub<void>();
  
  textDir:any;

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private _projectService: ProjectmanagementService,
    private _schoolService: SchoolManagementService,
    private _userService: UserManagementService,
    private util: ToolsService,
    private orderByPipe: OrderByPipe) {
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.environment = environment;
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('bodyBG_projectOverview');
    if (window.localStorage.getItem('loginInfoObj') == null) {
      console.log('token info missing');
      this.router.navigate(['/login']);
      return true;
    }
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData) {
      this.loggedInUser = userData;
    }

    this.propertyNameSorting = 'name';
    
    this.sub = this.route.params.subscribe(params => {
      this.project_id = params.project_id;
      if (this.project_id) {
        this.tabInit();
        this.getCountryList();
        this.getProjectData(this.project_id);
        this.getProjectSchoolData(this.project_id);
        this.getSubjectList();
      }
      this.gradeYearForm = this._fb.group({
        gradeArray: this._fb.array([]),
      });
    });

    this.translate.get('All categories').subscribe((translated: string) => {
      this.categorySelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        limitTo: 5
      };
      this.regionSelectConfig = {
        placeholder: this.translate.instant('All regions'),
        displayKey: 'name',
        search: false,
        limitTo: 6,
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        })
      };
      this.roleSelectConfig = {
        placeholder: this.translate.instant('All roles'),
        displayKey: 'desc',
        search: false,
        limitTo: 5
      };
      this.partnerSelectConfig = {
        placeholder: this.translate.instant('All organizations'),
        displayKey: 'name',
        search: false,
        limitTo: 5,
        customComparator: ((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        })
      };
    });

    if (window.localStorage.getItem('schoolAddSuccess')) {
      this.titleMessage = this.translate.instant('New school added');
      this.subTitleMessage = window.localStorage.getItem('schoolName');
      this.detailMessage = this.translate.instant('The appointed school administrator will be notified.');
      this.detailMessageLine1 = this.translate.instant('Please notify the recipient that this email may be filtered to a Spam or Junk mail folder.');
      //this.detailMessageLine1 = '';
      window.localStorage.removeItem('schoolAddSuccess');
      window.localStorage.removeItem('schoolName');
      this.openDialogModal('successModal');
    }

    if (window.localStorage.getItem('projectSetupSuccess')) {
      this.titleMessage = this.translate.instant('Project set-up complete');
      this.subTitleMessage = this.translate.instant('You have now added grades & subjects to your project.');
      this.detailMessage = this.translate.instant('You can now add schools.');
      window.localStorage.removeItem('projectSetupSuccess');
      this.openDialogModal('successModal');
    }
  }
  ngAfterViewInit() {
    this.tabInit();
  }
  log(val){ console.log(val); }
  tabInit(){
    const tabs = document.querySelectorAll('.tabs');
    if (tabs) {
      Array.from(tabs).forEach(tabGroup1 => {
        const tabGroup = new TabGroup(tabGroup1 as HTMLElement);
        tabGroup.init();
      });
    }
  }

  downloadCsv(data, type){
    this.util.generateCSV(data, type);
  }

  getYearList() {
    this._projectService.listYear().subscribe(
      (response) => {
        this.yearList = response.slice(0);
        this.openGradesModal();
        this.loaded = true;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
          // console.log('COMPLETED');
      }
    );
  }
  getRegionList(project_id) {
    this._schoolService.listRegion(project_id).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        this.regionList = response;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  getSubjectList() {
    return new Promise((resolve, reject) => {
      this._projectService.listSubject().subscribe(
        (response) => {
          this.subjectsList = response;
          this.subjectListAbs = [...response];
          this.loaded = true;
          this.tabInit();
        },
        (err) => {
          console.log('ERROR: ' + err);
          reject();
        },
        () => {
             // console.log("COMPLETED");
          resolve(true);
        }
      );
    });
  }
  getSchoolCategoryList() {
    //
    this._schoolService.listSchoolCategory().subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        this.schoolCategoryList = [...response];
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  getCountryList() {
    this._projectService.listCountry().subscribe(
      (response) => {
        this.countryList = response;
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        //  console.log('COMPLETED');
      }
    );
  }

  getPartnerList(data) {
    this._projectService.listPartner(data).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        this.partnerList = response;
        window.localStorage.setItem('partnerListObj', JSON.stringify(response));
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  getProjectData(project_id: string) {
   // console.log('project_id :' + this.project_id);
    this.loaded = false;
    this._projectService.detail(this.project_id).subscribe(
      (response) => {
        this.projectData = response[0];
        this.modalInfo = this.projectData.name + ', ' + this.projectData.country.name;
        this.projGradeList = this.projectData.grades.slice(0);
        this.selectedSubjectsList = this.projectData.subjects.slice(0);
        this.selectedSubjectsList = this.orderByPipe.transform(this.selectedSubjectsList, 'name');
        this.regenerateSubjectList();
        if (!Object.keys(this.projectData.grades[0]).length) {
            delete this.projectData.grades;
        } else {
          this.projectData.grades.forEach( value => {
            value.year.name = value.year.name + ' (' + value?.year?.description + ')';
          });
        }
        this.projLeadPartner = {};
        this.projPartnerList = this.projectData.partners;
        this.projAdminList = this.projectData.admins;
        if (typeof this.projAdminList !== 'undefined' && this.projAdminList.length >= 0){
          this.projOnlyAdminListArr = this.projAdminList.filter(x => {
            if (typeof x.admin.role !== 'undefined'){
              if (typeof x.admin.role.name !== 'undefined'){
                if (x.admin.role.name === 'ProjectAdmin' && x.admin.active === true){
                  return x;
                }
              }
            }
          });
        }

        this.projLeadPartner = this.projPartnerList.filter(x => x.type === 'Lead Partner')[0];
        console.log('projAdminList >>> ');
        console.log(this.projAdminList);
        if(this.projAdminList){
          this.projLeadAdmin = this.projAdminList.filter(x => x.type === 'Lead')[0];
        }
        
        this.country = this.projectData.country;

        this.projAdminList.forEach(element => {
          if (element.admin.hasOwnProperty('partner')){
            this.partnerListWithoutType.push(element.admin.partner);
          }
        });

        this.projOnlyAdminListArr.forEach(item => {
          item.admin.first_name = item.admin.first_name.charAt(0).toUpperCase() + item.admin.first_name.slice(1);
          this.projOnlyAdminList.push(item);
        });

        this.partnerListWithoutType = this.partnerListWithoutType.slice();

      //  console.log('partnerListWithoutType ' + JSON.stringify(this.partnerListWithoutType));

        this.roleList = [];
        this.userListData = [];
        this.projectData.admins.forEach(element => { 
          element.admin.type = element.type;
          if (element.admin.role && element.admin.role.name === 'ProjectAdmin' && element.admin.type == 'Lead') {
            element.admin.role.desc = 'Lead project administrator';
          } else if (element.admin.role && element.admin.role.name === 'ContentProvider') {
            element.admin.role.desc = 'Content provider';
          } else if (element.admin.role){
            element.admin.role.desc = 'Project administrator';
          }else{
            element.admin.role.desc = 'Project administrator';
          }
          this.roleList.push(element.admin.role);
          element.admin.name = element.admin.first_name + ' ' + element.admin.last_name;
          this.userListData.push(element.admin);
        });
        this.projectShortName = this.tabHeadingInitial(this.projectData.name);
        if (!this.projectData.grades){
          this.showSetupProject = true;
        }
        this.loaded = true;
        this.tabInit();
        return true;
      },
      (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
      },
      () => {
        if (this.first) {
          if ( this.projectData && this.projectData.grades) {
            this.showAddNewBtns(1);
          } else {
            this.showAddNewBtns(5);
          }
          this.first = false;
        }
        if (this.confirmFor === 'project') {
          this.closeDialogModal('successModal');
          if (this.projectData.active === true) {
            this.titleMessage = this.translate.instant('Project')+" " +this.translate.instant('Activated');
          } else {
            this.titleMessage = this.translate.instant('Project')+" " +this.translate.instant('Archived');
          }
          this.subTitleMessage = this.projectData.name + ', ' + this.projectData.country.name;
          this.detailMessage = '';
          this.detailMessageLine1 = '';

          this.confirmFor = '';
          this.openDialogModal('successModal');
        } else if (this.confirmFor === 'partner') {
          this.closeDialogModal('successModal');
          this.curPartner = this.projectData.partners.filter(x => x.partner.name === this.curPartner.name);
          console.log('curPartner after refresh ' + JSON.stringify(this.curPartner[0]));
          if (this.curPartner[0].partner.active === true) {
            this.titleMessage = this.translate.instant('Partner')+" " +this.translate.instant('Activated');
          } else {
            this.titleMessage = this.translate.instant('Partner')+" " +this.translate.instant('Archived');
          }
          this.subTitleMessage = this.curPartner[0].partner.name ;
          //this.subTitleMessage= this.curPartner[0].partner.name.charAt(0).toUpperCase() +this.curPartner[0].partner.name.slice(1);
          this.detailMessage = '';
          this.detailMessageLine1 = '';
          this.confirmFor = '';
          this.curPartner = '';
          this.openDialogModal('successModal');
        } else if (this.confirmFor === 'admin') {
          this.closeDialogModal('successModal');
          if (this.adminData.active === true) {
            this.titleMessage = this.translate.instant('Administrator')+" " +this.translate.instant('Archived') ;
          } else {
            this.titleMessage = this.translate.instant('Administrator')+" " +this.translate.instant('Activated');
          }
          this.adminData.first_name=this.adminData.first_name.charAt(0).toUpperCase()+this.adminData.first_name.slice(1);
          this.adminData.last_name=this.adminData.last_name.charAt(0).toUpperCase()+this.adminData.last_name.slice(1);
          this.subTitleMessage =  this.adminData.first_name + ' ' + this.adminData.last_name;
          this.detailMessage='';
          this.detailMessageLine1='';
          this.confirmFor = '';
          this.openDialogModal('successModal');
        }
      }
    );
  }

  refreshUserList(flag){
    this.getProjectData(this.project_id);
  }

  removeGrade(i) {
    const control = this.gradeYearForm.controls['gradeArray'] as FormArray;
    this.removeGradesArr.push(this.gradeYearForm.controls['gradeArray']['controls'][i].value.grade_id);
    control[i] = this._fb.group({
      name: '',
      year: this.yearList[i]
    });

  }
  onAddSubject(data) {
    if (data && data._id) {
      const i = this.selectedSubjectsList.findIndex(x => x.name === data.name);
      if (i === -1) {
        this.selectedSubjectsList.push(data);
        const i1 = this.subjectsList.findIndex(x => x.name === data.name);
        this.subjectsList.splice(i1, 1);
        this.subject = '';
        this.selectedSubjectsList = this.orderByPipe.transform(this.selectedSubjectsList, 'name');
      } else {
        this.subject = '';
        return;
      }
    } else if (data && data !== '') {
      data =  data.toLowerCase();
      data = data.charAt(0).toUpperCase() + data.slice(1).toLowerCase();
      this._projectService.addSubject({name: data}, this.project_id).subscribe(
        (response) => {
          this.selectedSubjectsList.push({name: data, _id: response.subject_id});
          this.subject = '';
          this.getSubjectList();
          const i1 = this.subjectsList.findIndex(x => x.name === data.name);
          this.subjectsList.splice(i1, 1);
          this.selectedSubjectsList = this.orderByPipe.transform(this.selectedSubjectsList, 'name');
        },
        (err) => {
             console.log('ERROR: ' + err);
        },
        () => {
             console.log('COMPLETED');
        }
      );
    }
    
  }
  saveSubjectsEdit() {
    const subjects = [];
    const tmp2 = this.selectedSubjectsList;
    tmp2.forEach(row => {
      if (row && row.name) {
        subjects.push(row._id);
      }
    });

    this._projectService.update(this.project_id, {subjects}).subscribe(
      (response) => {
        // alert("save subjects")
        this.closeDialogModal('confirmModal');
        this.getProjectData(this.project_id);
        if (this.removedSubjects.length > 0){
          this.titleMessage = this.translate.instant('Subjects')+" "+ this.translate.instant('removed');
          this.listMessage = this.removedSubjects;
          this.subTitleMessage = '';
          this.detailMessage = '';
          this.detailMessageLine1 = '';
          this.removedSubjects = [];
        }
        else{
          this.titleMessage = this.translate.instant('Subjects')+" "+ this.translate.instant('updated');
          this.subTitleMessage = this.projectData.name + ', ' + this.projectData.country.name;
          this.detailMessage = '';
          this.detailMessageLine1 = '';
          this.listMessage = [];
        }
        this.confirmFor = '';
        this.curPartner = '';
        this.openDialogModal('successModal');
      }
    );
  }

  removeWarning(){
    this.closeDialogModal('subjectsModal');
    if (this.isSubjectRemoved === true){
      this.titleMessage = this.translate.instant('Remove Subject(s)?');
      this.subTitleMessage = this.translate.instant('All students and teachers assigned to these subjects will become unassigned.');
      this.detailMessage  = '';
      this.listMessage = this.removedSubjects;
      // alert(JSON.stringify(this.detailMessage));
      this.detailMessageLine1 = this.translate.instant('If re-assignment is required this will need to be completed manually.');
     /*  this.openDialogModal('errorModal'); */
      this.openDialogModal('confirmModal');
      this.tabInit();
    }
    else{
      this.saveSubjectsEdit();
    }
  }

  cancelDelete(){
    this.closeDialogModal('errorModal');
  }

  saveGradesEdit() {
    const grades = [];
    const tmp1 = this.gradeYearForm.value.gradeArray;
    tmp1.forEach(row => {
      if (row && row.name) {
          grades.push({name: row.name, year: row.year._id});
      }
    });
    this._projectService.addProjectGrade(grades, this.project_id).subscribe(
      (response) => {

      this._projectService.removeGrade(this.removeGradesArr, this.project_id).subscribe(
        (response1) => {
          this.closeDialogModal('gradesModal');
          this.yearList = [];
          this.getProjectData(this.project_id);
          this.titleMessage = this.translate.instant('Grades')+" "+ this.translate.instant('updated');
          this.subTitleMessage = this.projectData.name + ', ' + this.projectData.country.name;
          this.detailMessage = '';
          this.detailMessageLine1 = '';
          this.confirmFor = '';
          this.curPartner = '';
          this.openDialogModal('successModal');
          this.tabInit();
        });

      }
    );

  }

  removeSubject(value) {
    this.isSubjectRemoved = true;
    this.removedSubjects.push(value);
    const j = this.selectedSubjectsList.findIndex(x => x.name === value.name);
    this.selectedSubjectsList.splice(j, 1);
    this.regenerateSubjectList();
  }
  regenerateSubjectList(){
    const removeArr = [];
    this.subjectsList = this.subjectListAbs.slice(0);
    this.subjectListAbs.forEach(value => {
      const j = this.selectedSubjectsList.findIndex(x => x.name === value.name);
      const k = this.subjectsList.findIndex(x => x.name === value.name);
      if (j !== -1){
        removeArr.push(k);
      }
    });
    removeArr.sort().reverse();
    removeArr.forEach((item) => {
        this.subjectsList.splice(item, 1);
    });
  }

  getProjectSchoolData(project_id: string) {
   // console.log('project_id :' + this.project_id);
    this.loaded = false;
    this._schoolService.list(this.project_id).subscribe(
      (response) => {
        this.schoolListData = response;
        this.schoolListDataAbs = response;

        if (!this.schoolListDataAbs.length){
          this.showAddNewSchool = true;
        }

        const sCategory = [];
        const sRegion = [];
        this.schoolListData.forEach(element => {
          if (sCategory.length < 1) {
            sCategory.push(element.category);
          } else if (sCategory.length > 1 && !sCategory.find(x => x.name === element.category.name)) {
            sCategory.push(element.category);
          }
          if (sRegion.length < 1) {
            sRegion.push(element.region);
          } else if (!sRegion.find(x => x.name === element.region.name)) {
            sRegion.push(element.region);
          }
        });
        this.schoolCategoryList = [...sCategory];
        this.regionList = [...sRegion];
        this.loaded = true;
        this.tabInit();
      },
      (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
      },
      () => {
       //   console.log('COMPLETED');
      }
    );
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG_projectOverview');
    this.sub.unsubscribe();
  }

  editProjectModal() {
    this.curView = 'read';
    this.btnTextAdd = '';
    this.btnStatusAdd = false;
    this.btnTextCancel = 'Close';
    this.btnTextEdit = 'Edit';
    this.btnStatusEdit = false;
    this.titleProjectModal = this.translate.instant('Edit Project Details');
    this.message = '';
    this.error = '';

    if (this.projectForm.errors) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }

    this.openDialogModal('projectModal');
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }


  enableProjectEdit() {

    this.btnTextAdd = 'Save';
    this.btnStatusAdd = true;
    this.btnTextEdit = '';
    this.btnStatusEdit = true;
    this.btnTextCancel = 'Cancel';
    this.curView = 'edit';
    this.projectForm.reset();
    this.projectForm.patchValue(this.projectData);

    this.projLeadAdmin.admin.first_name = this.projLeadAdmin.admin.first_name.charAt(0).toUpperCase() +
    this.projLeadAdmin.admin.first_name.slice(1);
    this.projLeadAdmin.admin.last_name = this.projLeadAdmin.admin.last_name.charAt(0).toUpperCase()
    + this.projLeadAdmin.admin.last_name.slice(1);
    if (typeof this.projLeadAdmin.admin.name === 'undefined'){
      this.projLeadAdmin.admin.name = this.projLeadAdmin.admin.first_name + ' ' + this.projLeadAdmin.admin.last_name;
    }
    // this.countryList = [this.projectData.country];
    this.projectForm.get('country').patchValue(this.projectData.country);
    this.projectForm.get('lpartner').patchValue(this.projLeadPartner.partner);
    this.projectForm.get('ladmin').patchValue(this.projLeadAdmin.admin);
    if (this.projectData.logo && this.projectData.logo.url) {
       this.projectForm.get('logo').patchValue(this.projectData.logo);
    }
    this.openDialogModal('projectModal');
  }

  projectFormChange(flag) {
    if (flag && this.projectForm.invalid && this.projectForm.errors) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
  }

  editProject() {

    if (this.curView === 'read') {
      this.enableDisableProject();
      return;
    }

    if (!this.project_id) {
      return false;
    }

    if (this.projectForm.invalid && this.projectForm.errors) {
      this.btnStatusAdd = true;
      return;
    }
   // console.log('Project Form Data ' + JSON.stringify(this.projectForm.value));
    // redirect on success
    const data = this.projectForm.value;
    data.country = this.projectForm.get('country').value._id;
    data.lpartner = this.projectForm.get('lpartner').value._id;
    data.ladmin = this.projectForm.get('ladmin').value._id;

    if (!data.logo) {
      delete data.logo;
    }

    delete data.partner;
    delete data.partners;
    delete data.admins;
    delete data.admin;

      /*
    this.projectForm.get('partners').value.forEach(element => {
      data.partners.push(element._id);
    });*/

    this._projectService.update(this.project_id, JSON.stringify(data)).subscribe(
      (response) => {
      //  console.log(' Full Response: ' + JSON.stringify(response));
        /*
        const navigationExtras: NavigationExtras = {
          queryParams: {
            'success': true
          }
        };
        this.router.navigate(['/projectmanagement'], navigationExtras);
        */
        this.btnTextCancel = 'Close';
        this.message = this.translate.instant('Project successfully updated!');
        this.btnTextAdd = '';
        if (this.project_id) {
          this.getProjectData(this.project_id);
        }
        this.titleMessage = this.translate.instant('Project')+" "+this.translate.instant('Updated');
        this.subTitleMessage = this.projectData.name;
        this.detailMessage = '';
        this.detailMessageLine1 = '';
        this.closeDialogModal('projectModal');
      },
      (err) => {
        console.log('ERROR: ' + err);
        this.titleMessage = this.translate.instant('Project')+" "+ this.translate.instant('Update')+" "+this.translate.instant('Failed');
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //  console.log('COMPLETED');
            this.subTitleMessage = data.name + ', ' + this.projectForm.get('country').value.name;
            this.detailMessage = '';
            this.closeDialogModal('projectModal');
            this.openDialogModal('successModal');
            this.loaded = true;
      }

    );
  }

  confirmEnableArchive(checkboxstatus) {
    if (this.projectData.active !== checkboxstatus ) {
      this.confirmFor = 'project';
      this.btnTextAdd = 'Save';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Cancel';
      this.btnTextEdit = '';
    } else {
      this.confirmFor = '';
      this.btnTextAdd = '';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Close';
      this.btnTextEdit = this.translate.instant('Edit');
    }
  }
  confirmEnableArchiveAdmin(checkboxstatus){
    if (this.adminData.active !== checkboxstatus ) {
      this.confirmFor = 'admin';
      this.btnTextAdd = 'Save';
      this.btnTextEdit = ''; 
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Cancel';
      this.btnTextSend = '';
    } else {
      this.confirmFor = '';
      this.btnTextAdd = '';
      this.btnStatusAdd = false;
      this.btnTextCancel = 'Close';
      this.btnTextSend = this.translate.instant('Email password reset');
    }
  }

  callEnableDisable() {
    if (this.confirmFor === 'project') {
      this.enableDisableProject();
    }
    if (this.confirmFor === 'partner') {
      this.enableDisablePartner();
    }
    
  }

  enableDisableProject() {
    if (this.projectData.active === true) {
      this.disableProject(this.project_id);
    } else {
      this.enableProject(this.project_id);
    }
  }
  disableProject(projectId) {
    this._projectService.disable(projectId).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getProjectData(this.project_id);
        this.getProjectSchoolData(this.project_id);
        this.closeDialogModal('projectModal');
      }
    );
  }

  enableProject(projectId) {
    this._projectService.enable(projectId).subscribe(
      (response) => {
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getProjectData(this.project_id);
        this.getProjectSchoolData(this.project_id);
        this.closeDialogModal('projectModal');
      }
    );
  }

  cancelProject() {
    //
    this.closeDialogModal('projectModal');
  }

  editProjectOverview(obj) {
    const navigationExtras: NavigationExtras = {
      // relativeTo: this.route
    };
    this.router.navigate(['/projectmanagement', 'editproject', this.project_id], navigationExtras);
  }

  openSchoolModal(data) {
    this.schoolForm.school_id = undefined;
    this.schoolForm.project_id = this.project_id;
    this.schoolForm.resetForm();
    this.btnStatusAdd = false;
    this.schoolForm.action = '';
    this.schoolForm.message = '';
    this.message = '';
    this.error = '';

    this.btnTextAdd = 'Add';
    this.btnTextCancel = 'Cancel';
    this.titleSchoolModal = this.translate.instant('Add')+" "+ this.translate.instant('New')+" "+this.translate.instant('School');

    if (data && data.name) {
      this.schoolForm.school_id = data._id;
      this.schoolForm.schoolForm.patchValue(data);
      this.btnTextAdd = this.translate.instant('Update');
      this.titleSchoolModal = this.translate.instant('Edit')+" "+this.translate.instant('School')+" "+this.translate.instant('Details');
    }

    if (this.schoolForm.schoolForm.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
    this.openDialogModal('schoolModal');
  }

  curSchoolFormChange(flag) {
    if (flag && this.schoolForm.schoolForm.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }

    if (this.schoolForm.action) {
      if (this.schoolForm.action === 'failure') {
        this.error = 'error';
      }
      this.message = this.schoolForm.message;
      this.btnTextCancel = 'Close';
      this.btnTextAdd = '';
      if (this.project_id) {
        this.getProjectSchoolData(this.project_id);
      }
    }

  }

  resetSchool() {
    alert('reset clicked');
    //
  }

  getfilteredData(filterType, data) {
    const filterList = { sort_by: '_id', sort_order: 'desc', filter_by: null, filter_value: null };
    if (typeof data.value !== 'undefined') {
      if (filterType === 'regionId') {
        this.filterBy.region = data.value._id;
      } else if (filterType === 'categoryId') {
        this.filterBy.category = data.value._id;
      }
    } else {
      if (filterType === 'regionId') {
        delete this.filterBy.region;
      } else if (filterType === 'categoryId') {
        delete this.filterBy.category;
      }
    }
    Object.keys(this.filterBy).forEach(key => {
      //
      if (this.filterBy[key]) {
        if (filterList.filter_by) {
          filterList.filter_by = filterList.filter_by + ',' + key;
          filterList.filter_value = filterList.filter_value + ',' + this.filterBy[key];
        } else {
          filterList.filter_by = key;
          filterList.filter_value = this.filterBy[key];
        }
      }
    });
    // console.log(filterList);
    this._schoolService.search(this.project_id, filterList).subscribe(
      (response) => {
        // console.log('VALUE project management: ' + JSON.stringify(response));
        this.schoolListData = response;
      },
      (err) => {
        console.log('ERROR: ' + err.status);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        // console.log('COMPLETED');
      }
    );
  }


  addSchool() {
    if (this.project_id) {
      this.schoolForm.project_id = this.project_id;
    }
    this.schoolForm.onSchoolFormSubmit();
  }

  cancelSchool() {
    //
  }
  openGradesModal()
  {
    this.error = '';
    this.message = '';
    this.btnStatusAdd = false;
    this.btnTextAdd = 'Save';
    this.btnTextCancel = 'Cancel';
    this.titlePartnerModal = this.translate.instant('Project')+" "+this.translate.instant('Grades');
    this._projectService.gradeCheck(this.project_id).subscribe(
      (response) => {
        this.gradecheckArr = response;
      }
    );
    this.openDialogModal('gradesModal');
  }
  openSubjectsModal()
  {
    this.isSubjectRemoved = false;
    this.error = '';
    this.message = '';
    this.btnStatusAdd = false;
    this.btnTextAdd = 'Save';
    this.btnTextCancel = 'Cancel';
    this.titlePartnerModal = this.translate.instant('Project')+" "+this.translate.instant('Subjects');
    this.tempSelectedSubjectsList = this.selectedSubjectsList;
    this.openDialogModal('subjectsModal');
  }
  openPartnerModal(data) {
    this.curPartner = '';
    this.partnerEnableDisable = false;
    this.partnerList = [];
    this.partnerData = {};
    if (this.project_id) {
      this.partnerForm.project_id = this.project_id;
    }
    this.partnerModalType = 'add';
    this.viewType = 'add';
    this.titlePartnerModal = this.translate.instant('Add')+" "+this.translate.instant('New')+" "+this.translate.instant('secondary partner');
    this.partnerForm.partnerType = this.translate.instant('Secondary partner');;
    this.partnerForm.partner_id = undefined;
    this.partnerForm.resetForm();
    this.partnerForm.action = '';
    this.partnerForm.message = '';
    this.error = '';
    this.message = '';

    this.btnTextAdd = 'Add';
    this.btnTextCancel = 'Cancel';
    this.btnTextEdit = '';
    if (data && data.partner && data.partner.name) {
      this.curPartner = data.partner;
      this.partnerList = data;
      this.partnerData = data;
      this.viewType = 'read';
      this.titlePartnerModal = '';
      this.partnerModalType = 'read';
      this.partnerForm.partnerType = data.type;
      this.partnerForm.project_id = this.project_id;
      this.partnerForm.partner_id = data.partner._id;
      this.partnerForm.partnerForm.patchValue(data.partner);
      this.partnerForm.partnerStatus = data.partner.active;
      this.btnTextAdd = '';
      this.btnTextEdit = this.translate.instant('Edit');
      this.btnTextCancel = 'Close';
    }
  
    if (this.loggedInUser.role.name === 'ProjectAdmin' && !this.loggedInUser.role.lead)
      this.btnTextEdit='';

    if (this.loggedInUser.role.name === 'ProjectAdmin' && this.loggedInUser.role.lead && data.type == 'Lead Partner') 
      this.btnTextEdit='';      
    
    this.btnStatusAdd = true;
    this.openDialogModal('partnerModal');
  }

  partnerFormChange(flag) {
    if (flag && this.partnerForm.partnerForm.invalid) {
      this.btnStatusAdd = true;
      // console.log("this.btnStatusAdd="+this.btnStatusAdd);
    } else {
      this.btnStatusAdd = false;
    //  console.log("this.btnStatusAdd="+this.btnStatusAdd);
    }

    if (this.partnerForm.action) {
      if (this.partnerForm.action === 'failure') {
        this.error = 'error';
      }
      this.message = this.partnerForm.message;
      this.btnTextCancel = 'Close';
      this.btnTextAdd = '';
      if (this.project_id) {
        this.getProjectData(this.project_id);
      }
    }

  }

  addPartner() {
    if (this.project_id) {
      this.partnerForm.project_id = this.project_id;
    }
    if (this.viewType === 'read') {
      if (this.partnerForm.partner_id) {
        this.enableDisablePartner();
        return;
      }
    }

    this.partnerForm.onPartnerFormSubmit();
    if (this.project_id) {
      this.getProjectData(this.project_id);
    }

    if (this.partnerForm.partner_id) {
      this.titleMessage = this.translate.instant('Partner')+" "+ this.translate.instant('updated');
    } else {
      this.titleMessage = this.translate.instant('Partner')+" "+ this.translate.instant('added');
    }
    this.detailMessage = '';

    this.detailMessageLine1 = '';
    this.subTitleMessage =  this.partnerForm.partnerForm.value.name;

    this.closeDialogModal('partnerModal');
    this.openDialogModal('successModal');
    this.tabInit();
  }

  closeModal(id) {
    if (id === 'subjectsModal') {
     this.selectedSubjectsList = this.projectData.subjects.slice(0);
    }else if (id === 'gradesModal'){

      this.yearList = [];
      // this.getProjectData(this.project_id);
    }
    this.closeDialogModal(id);
    this.loaded = true;
    this.cancelClicked.next();
  }
  cancelPartner() {
    this.closeDialogModal('partnerModal');
  }


  applyFilter(key,  data) {

    // user filters
    if (key === 'uname') {
      if (data && data.value) {
        this.uname = data.value.name;
      } else {
        this.uname = '';
      }
    }

    if (key === 'urole') {
      if (data && data.value) {
        this.urole = data.value.name;
      } else {
        this.urole = '';
      }
    }

    if (key === 'upart') {
      if (data && data.value) {
        this.upart = data.value.name;
      } else {
        this.upart = '';
      }
    }

    if (key === 'uclass') {
      if (data && data.value) {
      this.uclass = data.value;
      } else {
        this.uclass = '';
      }
    }
    if (key === 'ustatus') {
      if (data && data.value) {
        this.ustatus = data.value.active;
      } else {
        this.ustatus = '';
      }
    }
    if (key === 'ugrade') {
      if (data && data.value) {
        this.ugrade = data.value.name;
      } else {
        this.ugrade = '';
      }
    }
    if (key === 'usubject') {
      if (data && data.value) {
        this.usubject = data.value;
      } else {
        this.usubject = '';
      }

    }

  }


  openAdminModal(data) {
    this.btnSendStatus = false;
    this.userFormGroup = this._fb.group(projectforms.formAdmin);

    this.userFormGroup.reset();
    this.btnStatusAdd = true;

    this.admin_id = undefined;
    this.adminData = {};

    this.btnTextAdd =  this.translate.instant('Add');
    this.btnTextCancel =  'Cancel';
    this.titleAdminModal = this.translate.instant('Add new administrator');
    this.viewType = 'add';
    this.isProjectAdmin = false;

    this.btnTextEdit = '';

    this.btnTextSend = '';
    if (data && data.first_name) {
      this.adminData = {...data};
      this.viewType = 'read';
      this.admin_id = data._id;

      this.btnTextEdit = 'Edit';
      this.btnStatusEdit = false;

      this.userFormGroup.patchValue(data);
      if (data.active === true){
        this.btnTextSend = this.translate.instant('Email password reset');
      }
      this.titleAdminModal = '';
      this.btnTextCancel =  'Close';
      this.btnTextAdd = null;

      if (
        (this.loggedInUser.role.name === 'ProjectAdmin' &&
        this.projLeadAdmin.admin._id !== this.loggedInUser._id) ||
        data._id === this.loggedInUser._id) {
        this.btnTextSend = '';
        this.btnTextEdit='';
        this.isProjectAdmin = true;
      }
    }
    this.openDialogModal('adminModal');
  }

  enableAdminEdit() {
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = false;
    this.btnTextCancel =  'Cancel';
    this.btnTextSend = '';
    this.viewType = 'edit';
    this.btnTextEdit = '';
    this.titleAdminModal = '';
    this.userFormGroup.patchValue(this.adminData);
    this.userFormGroup.patchValue(this.adminData.role);
    // this.openDialogModal('adminModal');
  }
  enablePartnerEdit() {
    this.btnTextEdit='';
    this.btnTextAdd = 'Save';
    this.btnStatusAdd = false;
    this.btnTextCancel =  'Cancel';
    this.btnTextSend = '';
    this.viewType = 'edit';
    this.partnerModalType = 'edit';
    this.titleAdminModal = '';
    this.partnerForm.partnerForm.patchValue(this.partnerData);
    this.openDialogModal('partnerModal');
  }

  adminFormChange(flag) {
    // console.log('admin form flag ' + flag);
    // console.log("admin form invalid " + this.userFormGroup.invalid);
    if (flag && this.userFormGroup.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }

  }

  resetAdmin() {
    // alert('reset clicked');
    //
  }

  editAdminEvent() {
    this.viewType = 'edit';
    this.btnTextAdd = 'Save';
    this.btnTextCancel =  'Cancel';
    this.btnTextSend = null;
  }

  addAdmin() {
    if (this.project_id) {
      this.userForm.project_id = this.project_id;
    }

    if (this.viewType === 'read') {
      this.enableDisableAdmin();
      return;
    }

    this.userForm.onUserFormSubmit().then(res => this.getProjectData(this.project_id));

    if (this.viewType === 'edit') {
      this.confirmEditAdminSucces();
    } else {
      this.confirmAddAdminSuccess();
      this.viewType = 'view';
    }

  }

  confirmAddAdminSuccess(){
    this.titleMessage = this.translate.instant('Administrator added');  
    const adminName = window.localStorage.getItem('admin_name');
    this.subTitleMessage =  adminName;
    this.detailMessage = "";
    this.detailMessageLine1 = '';
    window.localStorage.removeItem('admin_name');
    this.closeDialogModal('adminModal');
    this.openDialogModal('successModal');
    this.tabInit();
  }

  confirmEditAdminSucces(){
    this.titleMessage = this.translate.instant('Details')+" "+ this.translate.instant('updated');
    this.subTitleMessage = window.localStorage.getItem('adminName');
    this.detailMessage = this.userForm.myFormGroup.controls.first_name.value + ' ' + this.userForm.myFormGroup.controls.last_name.value;

    this.detailMessageLine1 = '';
    this.closeDialogModal('adminModal');
    this.openDialogModal('successModal');
    this.tabInit();
  }

  cancelAdmin() {
    //
    this.closeDialogModal('adminModal');
    // this.viewType = 'view';
  }

  refreshPage() {
    window.location.reload();
  }

 /* adminFormChange() {
    console.log('admin form invalid ' + this.userFormGroup.invalid);
    console.log('admin form error ' + JSON.stringify(this.userFormGroup.errors));
    if (
      this.userFormGroup.get('role').invalid ||
      this.userFormGroup.get('first_name').invalid ||
      this.userFormGroup.get('last_name').invalid ||
      this.userFormGroup.get('partner').invalid ||
      this.userFormGroup.get('contact.email').invalid) {
      this.btnStatusAdd = false;
    } else {
      this.btnStatusAdd = true;
    }
  }*/



  downloadSchoolList(projectId: string) {
    this._schoolService.downloadSchoolList(projectId).subscribe(
      (response) => {
        console.log('download ' + response);
        this.downloadFile(response);
      }
    );
  }

  downloadPartnerList(projectId: string) {
    this._projectService.downloadPartnerList(projectId).subscribe(
      (response) => {
        console.log('download ' + response);
        this.downloadFile(response);
      }
    );
  }

  downloadAdminList(projectId: string) {
    this._projectService.downloadAdminList(projectId).subscribe(
      (response) => {
        console.log('download ' + response);
        this.downloadFile(response);
      }
    );
  }

  downloadFile(data: Blob) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  enableDisableSchool(obj) {
    if (obj.active === true) {
      this.disableSchool(obj);
    } else {
      this.enableSchool(obj);
    }
  }

  disableSchool(obj) {

    this._schoolService.disable(obj._id).subscribe(
        (response) => {
            this.getProjectSchoolData(this.project_id);
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          console.log('COMPLETED');
        }
    );
  }


  enableSchool(obj) {

    this._schoolService.enable(obj._id).subscribe(
      (response) => {
        this.getProjectSchoolData(this.project_id);
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  confirmPartnerEnableArchive(checkboxstatus) {    
    if (this.partnerData.partner.active !== checkboxstatus) {
      this.confirmFor = '';
      this.btnTextAdd = 'Save';
      this.btnStatusAdd = false;
      this.btnTextEdit='';
      this.btnTextCancel = 'Cancel';
    } else {    
      this.confirmFor = 'partner';
      this.btnTextAdd = '';
      this.btnStatusAdd = false;
      this.btnTextEdit = 'Edit';
      this.btnTextCancel = 'Close';
    }
  }

  enableDisablePartner() {
    if (this.curPartner.active === true) {
      this.disablePartner(this.curPartner);
    } else {
      this.enablePartner(this.curPartner);
    }
  }

  disablePartner(obj) {
    this._projectService.disablePartner(obj._id).subscribe(
        (response) => {
            // this.getProjectData(this.project_id);
            this.titleMessage = this.translate.instant('Partner')+" "+ this.translate.instant('archived');
            this.subTitleMessage =   obj.name;
            this.closeDialogModal('partnerModal');
            this.openDialogModal('successModal');
            this.tabInit();
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          this.getProjectData(this.project_id);
          this.getProjectSchoolData(this.project_id);
        }
    );
  }


  enablePartner(obj) {
    this._projectService.enablePartner(obj._id).subscribe(
      (response) => {
        this.titleMessage = 'Partner activated';
        this.subTitleMessage =  obj.name;
        this.closeDialogModal('partnerModal');
        this.openDialogModal('successModal');
        this.tabInit();
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getProjectData(this.project_id);
        this.getProjectSchoolData(this.project_id);
      }
    );
  }

  enableDisableAdmin() {
    if (this.adminData.active === true) {
      this.disableAdmin();
    } else {
      this.enableAdmin();
    }
  }

  disableAdmin() {
      this._userService.disable(this.userForm.user_id).subscribe(
        (response) => {
          // this.getProjectData(this.project_id);
        },
        (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }
        },
        () => {
          // this.getProjectData(this.project_id);
          console.log('COMPLETED');
          this.getProjectData(this.project_id);
          this.getProjectSchoolData(this.project_id);
          this.closeDialogModal('adminModal');
        }
    );
  }


  enableAdmin() {
    this._userService.enable(this.userForm.user_id).subscribe(
      (response) => {
        // this.getProjectData(this.project_id);
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        this.getProjectData(this.project_id);
        this.getProjectSchoolData(this.project_id);
        this.closeDialogModal('adminModal');
      }
    );
  }

  gotoSchoolOverview(obj) {
    const navigationExtras: NavigationExtras = {
      relativeTo: this.route,
    };
    this.router.navigate(['..', obj._id, 'view'], {relativeTo: this.route});
  }

  gotoAddSchool() {
    const navigationExtras: NavigationExtras = {
      relativeTo: this.route,
    };
    this.router.navigate(['..', 'addschool'], {relativeTo: this.route});
  }

  activateTab(code){
    switch (code){
      case 1:
        this.activeSetupProjectTab = false;
        this.activeSchoolTab = true;
        this.activeGradeTab = false;
        this.activePartnerTab = false;
        this.activePaTab = false;
        break;
      case 2:
        this.activeSetupProjectTab = false;
        this.activeSchoolTab = false;
        this.activeGradeTab = false;
        this.activePartnerTab = true;
        this.activePaTab = false;
        break;
      case 3:
        this.activeSetupProjectTab = false;
        this.activeSchoolTab = false;
        this.activeGradeTab = false;
        this.activePartnerTab = false;
        this.activePaTab = true;
        break;
      case 4:
        this.activeSetupProjectTab = false;
        this.activeSchoolTab = false;
        this.activeGradeTab = true;
        this.activePartnerTab = false;
        this.activePaTab = false;
        break;
      case 5:
        this.activeSetupProjectTab = true;
        this.activeSchoolTab = false;
        this.activeGradeTab = false;
        this.activePartnerTab = false;
        this.activePaTab = false;
    }
  }

  showAddNewBtns(obj?){
    const btnAddSchool = document.querySelector('#btn_add_new_school') as HTMLElement;
    const btnAddPartner = document.querySelector('#btn_add_new_partner') as HTMLElement;
    const btnAddAdmin = document.querySelector('#btn_add_new_admin') as HTMLElement;
    if (btnAddSchool){
      btnAddSchool.style.display = 'none';
    }
    if (btnAddPartner){
      btnAddPartner.style.display = 'none';
    }
    if (btnAddAdmin){
      btnAddAdmin.style.display = 'none';
    }

    if (obj === 1){ // show school
      if (btnAddSchool){
        btnAddSchool.style.display = 'block';
        this.activateTab(1);
      }
    } else if (obj === 2){ // show partner
      btnAddPartner.style.display = 'block';
      this.activateTab(2);
    } else if (obj === 3){ // show admin
      btnAddAdmin.style.display = 'block';
      this.activateTab(3);
    } else if (obj === 4){
      this.activateTab(4);
    } else if(obj === 5){
      this.activateTab(5);
    }
    if (obj !== 1 && obj !== 2 && obj !== 3 && obj !== 5) {
      if (btnAddSchool){
        btnAddSchool.style.display = 'none';
      }

      if (btnAddPartner){
        btnAddPartner.style.display = 'none';
      }

      if (btnAddAdmin){
        btnAddAdmin.style.display = 'none';
      }
    }

    if (obj === 3) {
      this.sortByDefault('first_name');
    }
    this.tabInit();
  }

  tabHeadingInitial(data){
    let temp1;
    let temp2;
    if (data !== undefined)
    {
      const temp = data.split(' ');
      temp1 = temp[0].charAt(0).toUpperCase();
      if (temp.length > 1) {
      //temp2 = temp[1].charAt(0).toUpperCase();
        temp2 = temp[1].charAt(0).toLowerCase();
      } else {
        temp2 = temp[0].charAt(1).toUpperCase();
      }
    }
    return temp1 + temp2;
  }
  setIconColor(str, status) {
    str = this.tabHeadingInitial(str);
    if (status !== true) {
      return { 'background-color': '#b3b2ad'};
    }
  }

  setGrid() {
   this.gridView = true;
   this.noOfItems = 9;
   this.getfilteredData('default', 'default');
  }
  setList() {
    this.gridView = false;
    this.noOfItems = 18;
    this.getfilteredData('default', 'default');
  }

  setupYourProject() {
    this.router.navigate(['/projectmanagement',this.project_id, 'setup']);
  }

  sendMail() {

    const user = {user_id: '', first_name: '', last_name: '', email: ''};
    user.user_id = this.adminData._id;
    user.first_name = this.adminData.first_name;
    user.last_name = this.adminData.last_name;
    user.email = this.adminData.contact.email;
    console.log('sending mail to' + JSON.stringify(user));
    this._projectService.sendMail(user).subscribe(
      (response) => {
       this.btnSendStatus = true;
       this.btnTextSend = this.translate.instant('Password Email Sent');
      }
    );
  }
  /* Sorting functionality added - KAJAL */
  sortByDefault(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    this.orderType = true;
    this.propertyNameSorting = propertyName;
  }
  sortBy(propertyName){
    this.isSorted = true;
    this.sortedClass = '';
    this.propertyName = propertyName;
    if (propertyName !== null && this.propertyName === propertyName){
      if (this.orderType === true){
        this.orderType = false;
        this.propertyNameSorting = propertyName;
        this.sortedClass = 'asc';
      }else{
        this.orderType = true;
        this.propertyNameSorting = '-' + propertyName;
        this.sortedClass = 'desc';
      }
    }
  }

  fixLogoUrl(url?) {
    if (url) {
     if (url.match('undefined')) {
       return url.replace('undefined', environment.msdpAPIBaseURL);
     } else if (url.match('FILEBASEURL')) {
       return url.replace('<FILEBASEURL>', environment.msdpAPIBaseURL);
     } else {
       return url;
     }
    }
    return 'null';
  }
}
